import {
  Box,
  Flex,
  Grid,
  Heading,
  isNotNil,
  mdBumps,
  smBumps,
  TertiaryButton,
  Typo,
  xxsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'

import {
  toDisplacementKBA,
  toFuelTypeKBA,
  toKBA,
  toPerformanceKBA,
  toTsnYearLabelKBA,
  toVariantKBA,
  VehicleKBA,
} from '../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'

export interface KBAVehicleCardProps {
  onChange?: (data: null) => void
  value: VehicleKBA
}

const tKey = TKey('components.vehicle-card')

export const VehicleCardKBA: FunctionComponent<KBAVehicleCardProps> = ({
  value,
  onChange,
}) => {
  const { t } = useWriskTranslation()

  const handleChange = useCallback(() => {
    onChange?.(null)
  }, [onChange])

  const elements = Object.entries({
    kba: toKBA(value),
    tsnYearRange: toTsnYearLabelKBA(t)(value),
    performance: toPerformanceKBA(value),
    displacement: toDisplacementKBA(value),
    fuelType: toFuelTypeKBA(t)(value),
  })
    .filter(([, value]) => isNotNil(value))
    .flatMap(([key, value]) => [
      <Typo color='bodySecondary' typoSize='sm' key={`title-${key}`}>
        {t(tKey('titles', key))}
      </Typo>,
      <Typo typoSize='sm' key={`value-${key}`}>
        {value}
      </Typo>,
    ])

  return (
    <Box
      width={1}
      variant='raised'
      p={mdBumps}
      flexWrap='wrap'
      data-testid='vehicle-card'
    >
      <Flex width={1} marginBottom={smBumps} alignItems='center'>
        <Heading typoSize='md' pb={1} mr={smBumps}>
          {toVariantKBA(value)}
        </Heading>
        <TertiaryButton
          whiteSpace='nowrap'
          data-testid='vehicle-change'
          layout='small'
          onClick={handleChange}
        >
          Ändern
        </TertiaryButton>
      </Flex>
      <Grid
        gridTemplateColumns={['1fr 1fr', '1fr 1fr', '1fr 1fr', '1fr 2fr']}
        gap={xxsBumps}
      >
        {elements}
      </Grid>
    </Box>
  )
}
